import { useTheme } from "@emotion/react";
import React, { forwardRef } from "react";

import { Box, Grid } from "~/components/blocks";
import { AppFooter, AppHeader } from "~/components/partials";

type Props = {
  terms?: boolean;
  policy?: boolean;
  title: string;
  children: React.ReactNode;
  backText?: string;
  onBack?: () => void;
};

export const PharmacyAppShell = forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const theme = useTheme();

    return (
      <Box height="100%" overflow="auto" ref={ref}>
        <Grid gridTemplateRows="min-content 1fr">
          <AppHeader
            title={props.title}
            backText={props.backText}
            onBack={props.onBack}
          />
          {props.children}
        </Grid>
        <AppFooter
          textAlign="center"
          marginY={theme.space.l}
          terms={props.terms}
          policy={props.policy}
        />
      </Box>
    );
  },
);

PharmacyAppShell.displayName = "PharmacyAppShell";
